export default __webpack_public_path__ + "static/media/pin_1.aaeaafe7.png";